import React, { useState, useContext, useEffect, useRef } from "react";

import FileDownloadIcon from "@mui/icons-material/FileDownload";

import Measurement from "./Measurement";
import AddComment from "./AddComment";
import { Box, Card, Grid, Button } from "@mui/material";
import { ColorModeContext } from "../context/ColorModeProvider";
import { useUserProvider } from "../context/UserProvider";
import { useWallProvider } from "../context/WallProvider";
import { firestore } from "../firebase";
import { useParams, Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  QuerySnapshot,
  getDocs,
} from "firebase/firestore";

const Measurements = ({
  site,
  wall,
  measurements,
  onCreate,
  siteRef,
  wallsRef,
  formData,
  siteId,
  wallId,
  sideRoom1Name,
  sideRoom2Name,
  stackedRoom1Name,
  stackedRoom2Name,
  roomDisposalDependingBeforeWorks,
  roomDisposalDependingAfterWorks,
}) => {
  const { theme } = useContext(ColorModeContext);
  const { user } = useUserProvider();

  const [download, setDownload] = useState([]);

  const downloadLink = useRef();

  // const { id: measurementId } = useParams();

  // const siteRef = firestore.doc(`sites/${siteId}`);

  const downloadMyCollection = async () => {
    const myCollection = collection(
      firestore,
      `sites/${siteId}/walls/${wallId}/measurements`
    );
    const data = await getDocs(myCollection);
    setDownload(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    if (!!download.length) downloadLink.current.click();
  }, [download]);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  return (
    <>
      {measurements?.map((measurement) => (
        <Measurement
          {...measurement}
          {...site}
          {...wall}
          wallId={wallId}
          siteId={siteId}
          key={measurement.id}
          sideRoom1Name={formData.sideRoom1Name}
          sideRoom2Name={formData.sideRoom2Name}
          stackedRoom1Name={formData.stackedRoom1Name}
          stackedRoom2Name={formData.stackedRoom2Name}
          roomDisposalDependingBeforeWorks={
            formData.roomDisposalDependingBeforeWorks
          }
          roomDisposalDependingAfterWorks={
            formData.roomDisposalDependingAfterWorks
          }
          // siteRef={siteRef}
          {...user}
          // siteId={siteId}
          // wallId={wallId}
          // key={wall.cresateAt}
          registrationPeriod={formData.registrationPeriod}
          // formdata={wall.formData}
        />
      ))}

      <>
        {!user || measurements.length === 0 ? (
          ""
        ) : (
          <Grid align="right">
            <Button
              component="a"
              endIcon={<FileDownloadIcon fontSize="small" />}
              sx={{ mt: 2 }}
              variant={isSmallScreen ? "contained" : "outlined"}
              size={isSmallScreen ? "large" : "small"}
              className={
                isSmallScreen ? "downloadButton xsButton" : "downloadButton"
              }
              onClick={downloadMyCollection}
            >
              Export measurements data
            </Button>
            <br />
            <a
              href={`data:text/json;charset=utf-8,${encodeURIComponent(
                JSON.stringify(download)
              )}`}
              download="acoustic_measurements.json"
              className="hidden"
              ref={downloadLink}
              style={{ visibility: "hidden" }}
            >
              isHidden
            </a>
          </Grid>
        )}
      </>
    </>
  );
};

export default Measurements;
